import { H3, List } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import React from 'react';
import styled from 'styled-components';

import { BodyWrapper, ImageWrapper, StyledClickable, StyledDescription, StyledImage, TileWrapper } from './styles';
import { ImageObject, UrlObject } from '../../../../../../types/__codegen__/sanity/graphql';

export type ProductProps = {
  cta: UrlObject;
  description: string;
  imageObject: ImageObject;
  listItems?: string[];
  title: string;
};

const StyledList = styled(List)`
  padding-left: 2rem;
  margin-bottom: 2rem;
`;

const ProductTile = ({ cta, description, imageObject, listItems, title }: ProductProps) => {
  const imageUrl = imageObject?.image?.asset?.url;

  return (
    <TileWrapper>
      {imageUrl && (
        <ImageWrapper>
          <StyledImage alt={imageObject.caption ?? ''} src={imageUrl} />
        </ImageWrapper>
      )}
      <BodyWrapper>
        {title && <H3>{title}</H3>}
        {description && <StyledDescription>{description}</StyledDescription>}
        {listItems && (
          <StyledList>
            {map(
              (item) => (
                <li>
                  <StyledDescription>{item}</StyledDescription>
                </li>
              ),
              listItems,
            )}
          </StyledList>
        )}
        {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: No overload matches this call. */}
        {cta && <StyledClickable to={cta.url}>{cta.name}</StyledClickable>}
      </BodyWrapper>
    </TileWrapper>
  );
};

export default ProductTile;
